import type { IngredientId } from '@libs/trip-planner-interfaces';

import type { EditTripSegment } from './editTripSegment';

export enum EditTripStepType {
  Overview = 'Overview',
  AddDestination = 'AddDestination',
  UpdateDestination = 'UpdateDestination',
  AddDestinationToOwnStay = 'AddDestinationToOwnStay',
}

export interface EditTripOverviewStep {
  stepType: EditTripStepType.Overview;
  isInitialStep?: boolean;
}

interface EditTripAddDestinationStep {
  stepType: EditTripStepType.AddDestination;
  isInitialStep?: boolean;
}

interface EditTripUpdateDestinationStep {
  stepType: EditTripStepType.UpdateDestination;
  currentEditingSegment: EditTripSegment;
  isInitialStep?: boolean;
}

interface EditTripAddDestinationToOwnStayStep {
  stepType: EditTripStepType.AddDestinationToOwnStay;
  ownStayDestinationIngredeintId: IngredientId;
  isInitialStep?: boolean;
}

export type EditTripSelectDestinationStep =
  | EditTripAddDestinationStep
  | EditTripUpdateDestinationStep
  | EditTripAddDestinationToOwnStayStep;

export type EditTripStep = EditTripOverviewStep | EditTripSelectDestinationStep;
